import { useAuth } from '@/auth/auth-provider'
import { isSuper, parsePrincipalFromUser } from '@/auth/principal'
import { Center, Loader, Stack, Text } from '@mantine/core'
import { ReactNode, useMemo } from 'react'
import { Navigate } from 'react-router-dom'

/** Matches `AccessService.isSuper` — gates internal / admin UI only. */
export function RequireSuper({ children }: { children: ReactNode }) {
  const { user, isLoading, isAuthenticated } = useAuth()
  const isSuperUser = useMemo(() => isSuper(parsePrincipalFromUser(user)), [user])

  if (isLoading || !isAuthenticated) {
    return (
      <Center h="50vh">
        <Stack align="center" gap="sm">
          <Loader size="md" />
          <Text size="sm" c="dimmed">
            Loading…
          </Text>
        </Stack>
      </Center>
    )
  }

  if (!isSuperUser) {
    return <Navigate to="/unauthorized" replace />
  }

  return <>{children}</>
}
